var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContentsVisibilityIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.50006 6.18182C7.22119 6.18182 6.18188 7.22113 6.18188 8.50001C6.18188 9.77888 7.22119 10.8182 8.50006 10.8182C9.77893 10.8182 10.8182 9.77888 10.8182 8.50001C10.8182 7.22113 9.7789 6.18182 8.50006 6.18182Z",
    fill: "#727E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50002 2.70456C4.63637 2.70456 1.33683 5.10772 0 8.50002C1.33683 11.8923 4.63637 14.2955 8.50002 14.2955C12.3675 14.2955 15.6632 11.8923 17 8.50002C15.6632 5.10772 12.3675 2.70456 8.50002 2.70456ZM8.50002 12.3636C6.36729 12.3636 4.63637 10.6327 4.63637 8.49998C4.63637 6.36725 6.36729 4.63637 8.50002 4.63637C10.6327 4.63637 12.3637 6.36729 12.3637 8.50002C12.3637 10.6327 10.6327 12.3636 8.50002 12.3636Z",
    fill: "#727E8C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentsVisibilityIcon);
export default __webpack_public_path__ + "static/media/contents-visibility-icon.fe3b3f62.svg";
export { ForwardRef as ReactComponent };